// extracted by mini-css-extract-plugin
export var alternate = "_x-j";
export var black = "_x-6";
export var blue = "_x-f";
export var blueLight = "_x-e";
export var brand = "_x-8";
export var darkMode = "_x-b";
export var error = "_x-a";
export var gray = "_x-5";
export var grayBlue = "_x-d";
export var iconWrapper = "_x-3";
export var inactive = "_x-7";
export var indigo = "_x-g";
export var orange = "_x-i";
export var pink = "_x-h";
export var primary = "_x-0";
export var purple = "_x-9";
export var success = "_x-4";
export var warning = "_x-c";
export var white = "_x-1";
export var whiteSuccess = "_x-2";